<template>
  <div class="row mt-4" v-if="datos.ventas_con_cupon > 0">
    <div class="col-12">
      <div class="card ficha-listado">
        <div class="px-4 pb-4 card-body">

          <div class="mb-3">
            <h6 class="mb-0 panel-section-title">Efectividad de descuentos</h6>
            <p class="text-xs opacity-7 mb-0">Comparativa de ventas con cupón vs sin cupón</p>
          </div>

          <!-- KPIs con vs sin cupón -->
          <div class="row g-2 mb-4">
            <div class="col-6 col-md-3">
              <div class="ed-kpi ed-kpi--cupon">
                <div class="ed-kpi__k">Ventas con cupón</div>
                <div class="ed-kpi__v">{{ datos.ventas_con_cupon }}</div>
                <div class="ed-kpi__sub">{{ datos.tasa_uso }}% del total</div>
              </div>
            </div>
            <div class="col-6 col-md-3">
              <div class="ed-kpi">
                <div class="ed-kpi__k">Ventas sin cupón</div>
                <div class="ed-kpi__v">{{ datos.ventas_sin_cupon }}</div>
                <div class="ed-kpi__sub">{{ pctSin }}% del total</div>
              </div>
            </div>
            <div class="col-6 col-md-3">
              <div class="ed-kpi ed-kpi--cupon">
                <div class="ed-kpi__k">Ticket con cupón</div>
                <div class="ed-multi">
                  <span v-if="datos.ticket_con_cupon_eur > 0" class="ed-cur ed-cur--eur">{{ fmtEur(datos.ticket_con_cupon_eur) }}</span>
                  <span v-if="datos.ticket_con_cupon_usd > 0" class="ed-cur ed-cur--usd">{{ fmtUsd(datos.ticket_con_cupon_usd) }}</span>
                  <span v-if="!datos.ticket_con_cupon_eur && !datos.ticket_con_cupon_usd" class="ed-cur ed-cur--eur">—</span>
                </div>
              </div>
            </div>
            <div class="col-6 col-md-3">
              <div class="ed-kpi">
                <div class="ed-kpi__k">Ticket sin cupón</div>
                <div class="ed-multi">
                  <span v-if="datos.ticket_sin_cupon_eur > 0" class="ed-cur ed-cur--eur">{{ fmtEur(datos.ticket_sin_cupon_eur) }}</span>
                  <span v-if="datos.ticket_sin_cupon_usd > 0" class="ed-cur ed-cur--usd">{{ fmtUsd(datos.ticket_sin_cupon_usd) }}</span>
                  <span v-if="!datos.ticket_sin_cupon_eur && !datos.ticket_sin_cupon_usd" class="ed-cur ed-cur--eur">—</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Barra comparativa visual -->
          <div class="ed-bar-wrap mb-4">
            <div class="ed-bar-label text-xs mb-1">Distribución de ventas</div>
            <div class="ed-bar-track">
              <div
                class="ed-bar-seg ed-bar-seg--cupon"
                :style="{ width: pctCuponBar }"
                :title="`Con cupón: ${datos.ventas_con_cupon} ventas`"
              >
                <span v-if="datos.tasa_uso >= 8" class="ed-bar-seg__label">{{ datos.tasa_uso }}%</span>
              </div>
              <div
                class="ed-bar-seg ed-bar-seg--sin"
                :style="{ width: pctSinBar }"
                :title="`Sin cupón: ${datos.ventas_sin_cupon} ventas`"
              >
                <span v-if="pctSin >= 8" class="ed-bar-seg__label">{{ pctSin }}%</span>
              </div>
            </div>
            <div class="ed-bar-legend">
              <span><span class="ed-dot ed-dot--cupon"></span> Con cupón</span>
              <span><span class="ed-dot ed-dot--sin"></span> Sin cupón</span>
            </div>
          </div>

          <!-- Tabla por código -->
          <div v-if="datos.por_codigo && datos.por_codigo.length">
            <p class="text-xs fw-bold text-uppercase opacity-7 mb-2">Rendimiento por cupón</p>
            <div class="table-responsive">
              <table class="table table-sm ed-table">
                <thead>
                  <tr>
                    <th class="th-sort" @click="sortByCod('codigo')">Código <span class="si">{{ iconCod('codigo') }}</span></th>
                    <th class="text-center">Descuento</th>
                    <th class="th-sort text-end" @click="sortByCod('usos')">Usos <span class="si">{{ iconCod('usos') }}</span></th>
                    <th class="th-sort text-end" @click="sortByCod('importe_eur')">€ <span class="si">{{ iconCod('importe_eur') }}</span></th>
                    <th class="th-sort text-end" @click="sortByCod('importe_usd')">$ <span class="si">{{ iconCod('importe_usd') }}</span></th>
                    <th class="th-sort text-end" @click="sortByCod('ticket_eur')">Ticket € <span class="si">{{ iconCod('ticket_eur') }}</span></th>
                    <th class="th-sort text-end" @click="sortByCod('ticket_usd')">Ticket $ <span class="si">{{ iconCod('ticket_usd') }}</span></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="c in porCodigoSorted" :key="c.codigo">
                    <td><code class="ed-code">{{ c.codigo }}</code></td>
                    <td class="text-center">
                      <span class="ed-pct-badge">-{{ c.porcentaje }}%</span>
                    </td>
                    <td class="text-end fw-bold">{{ c.usos }}</td>
                    <td class="text-end">{{ c.importe_eur > 0 ? fmtEur(c.importe_eur) : '—' }}</td>
                    <td class="text-end">{{ c.importe_usd > 0 ? fmtUsd(c.importe_usd) : '—' }}</td>
                    <td class="text-end">{{ c.ticket_eur > 0 ? fmtEur(c.ticket_eur) : '—' }}</td>
                    <td class="text-end">{{ c.ticket_usd > 0 ? fmtUsd(c.ticket_usd) : '—' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PanelTipsterEfectividadDesc",
  data() {
    return { sortCod: 'usos', sortCodDir: 'desc' };
  },
  props: {
    datos: {
      type: Object,
      default: () => ({
        ventas_con_cupon: 0, ventas_sin_cupon: 0,
        tasa_uso: 0,
        ticket_con_cupon_eur: 0, ticket_con_cupon_usd: 0,
        ticket_sin_cupon_eur: 0, ticket_sin_cupon_usd: 0,
        por_codigo: [],
      }),
    },
  },
  computed: {
    porCodigoSorted() {
      const arr = [...(this.datos.por_codigo || [])];
      if (!this.sortCod) return arr;
      const dir = this.sortCodDir === 'asc' ? 1 : -1;
      return arr.sort((a, b) => {
        const va = this.sortCod === 'codigo' ? (a.codigo || '').toLowerCase() : (a[this.sortCod] ?? 0);
        const vb = this.sortCod === 'codigo' ? (b.codigo || '').toLowerCase() : (b[this.sortCod] ?? 0);
        if (va < vb) return -dir; if (va > vb) return dir; return 0;
      });
    },
    totalVentas() { return (this.datos.ventas_con_cupon || 0) + (this.datos.ventas_sin_cupon || 0); },
    pctSin()      { return this.totalVentas > 0 ? (100 - this.datos.tasa_uso).toFixed(2) : "0.00"; },
    pctCuponBar() { return `${this.datos.tasa_uso || 0}%`; },
    pctSinBar()   { return `${parseFloat(this.pctSin)}%`; },
  },
  methods: {
    sortByCod(col) {
      if (this.sortCod === col) { this.sortCodDir = this.sortCodDir === 'asc' ? 'desc' : 'asc'; }
      else { this.sortCod = col; this.sortCodDir = col === 'codigo' ? 'asc' : 'desc'; }
    },
    iconCod(col) { return this.sortCod !== col ? '↕' : this.sortCodDir === 'asc' ? '↑' : '↓'; },
    fmtEur(n) {
      return Number(n || 0).toLocaleString("es-ES", { style: "currency", currency: "EUR" });
    },
    fmtUsd(n) {
      return Number(n || 0).toLocaleString("en-US", { style: "currency", currency: "USD" });
    },
  },
};
</script>

<style scoped>
.ed-kpi {
  background: var(--q-card);
  border: 1px solid var(--q-border);
  border-radius: 12px;
  padding: 12px 14px;
  min-height: 86px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
}
.ed-kpi--cupon { background: var(--q-hover); border-color: var(--q-border); }
.ed-kpi__k {
  font-size: 11px; color: var(--q-muted); font-weight: 600;
  text-transform: uppercase; letter-spacing: .4px;
}
.ed-kpi__v  { font-size: 20px; font-weight: 800; color: var(--q-gold); line-height: 1.1; }
.ed-kpi:not(.ed-kpi--cupon) .ed-kpi__v { color: var(--q-text); }
.ed-kpi__sub { font-size: 10px; color: var(--q-muted); }

/* Multi-moneda dentro de kpi */
.ed-multi {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 8px;
  align-items: baseline;
}
.ed-cur {
  font-size: 16px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.ed-cur--eur { color: var(--q-gold); }
.ed-cur--usd { color: #26c6da; }
.ed-kpi:not(.ed-kpi--cupon) .ed-cur--eur { color: var(--q-text); }

/* Barra comparativa */
.ed-bar-wrap { max-width: 560px; }
.ed-bar-label { color: var(--q-muted); font-weight: 600; }
.ed-bar-track {
  display: flex;
  height: 28px;
  border-radius: 8px;
  overflow: hidden;
  background: var(--q-hover);
}
.ed-bar-seg {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: width .4s ease;
}
.ed-bar-seg--cupon { background: linear-gradient(90deg, var(--q-gold), var(--q-gold-hover)); }
.ed-bar-seg--sin   { background: var(--q-border); }
.ed-bar-seg__label { font-size: 11px; font-weight: 700; color: #fff; }
.ed-bar-seg--sin .ed-bar-seg__label { color: var(--q-muted); }

.ed-bar-legend {
  display: flex;
  gap: 16px;
  margin-top: 6px;
  font-size: 11px;
  color: var(--q-muted);
}
.ed-dot { display: inline-block; width: 8px; height: 8px; border-radius: 50%; margin-right: 4px; vertical-align: middle; }
.ed-dot--cupon { background: var(--q-gold); }
.ed-dot--sin   { background: var(--q-border); border: 1px solid var(--q-border-md); }

.th-sort { cursor: pointer; user-select: none; white-space: nowrap; }
.th-sort:hover { color: var(--q-gold); }
.si { font-size: 0.7rem; opacity: 0.55; margin-left: 2px; }
.th-sort:hover .si { opacity: 1; color: var(--q-gold); }

/* Tabla */
.ed-table { font-size: 12px; border-collapse: collapse; }
.ed-table th,
.ed-table td { border: none !important; box-shadow: none !important; }
.ed-table thead th {
  font-size: 10px; text-transform: uppercase;
  color: var(--q-muted); font-weight: 600;
  border-bottom: 1px solid var(--q-border) !important; padding: 4px 8px;
}
.ed-table tbody td { padding: 7px 8px; border-bottom: 1px solid var(--q-border) !important; color: var(--q-text); }

.ed-code {
  background: var(--q-hover); color: var(--q-gold);
  font-size: 12px; font-weight: 700;
  padding: 2px 7px; border-radius: 5px;
  border: none; box-shadow: none;
}
.ed-pct-badge {
  background: var(--q-amber-soft); color: var(--q-amber);
  font-size: 11px; font-weight: 700;
  padding: 2px 8px; border-radius: 20px;
}
</style>
